<template>
  <div>
    <h3>Widerrufsrecht</h3>
    <sui-list>
      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Widerrufsrecht</sui-list-header>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden diesen Vertrag zu widerrufen.
          Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag des Vertragsabschlusses.
          Um Ihr Widerrufsrecht auszu&uuml;ben, m&uuml;ssen Sie uns (LAN1 Hotspots GmbH, Gau&szlig;stra&szlig;e 158, 22765 Hamburg, Tel.: +49 (0)40 317 66 66 0, Fax: +49 (0)40 317 66 66 33, E-Mail: info@lan1.de) mittels einer eindeutigen Erkl&auml;rung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) &uuml;ber Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie k&ouml;nnen daf&uuml;r das beigef&uuml;gte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
        </sui-list-content>
      </sui-list-item>
      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Folgen des Widerrufs</sui-list-header>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschlie&szlig;lich der Lieferkosten (mit Ausnahme der zus&auml;tzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, g&uuml;nstigste Standardlieferung gew&auml;hlt haben), unverz&uuml;glich und sp&auml;testens binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an dem die Mitteilung &uuml;ber Ihren Widerruf dieses Vertrags bei uns eingegangen ist. F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der urspr&uuml;nglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdr&uuml;cklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser R&uuml;ckzahlung Entgelte berechnet.
        </sui-list-content>
      </sui-list-item>
    </sui-list>

    <h3>--- Anlage Muster-Widerrufsformular ---</h3>
    <pre>
Muster-Widerrufsformular
(Wenn Sie den Vertrag widerrufen wollen, dann f&uuml;llen Sie bitte dieses Formular aus und senden Sie es zur&uuml;ck.)
- An
  LAN1 Hotspots GmbH
  Gau&szlig;stra&szlig;e 158
  22765 Hamburg
  Fax: +49 (0)40 317 66 66 33
  E-Mail: info@lan1.de

- Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag &uuml;ber den Kauf der folgenden Waren (*)/ die Erbringung der folgenden Dienstleistung (*)
- Bestellt am (*)/erhalten am (*)
- Name des/der Verbraucher(s)
- Anschrift des/der Verbraucher(s)
- Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)
- Datum

___________
(*) Unzutreffendes streichen.
        </pre>


    <h3>Instructions on withdrawal</h3>
    <sui-list>
      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Right of withdrawal</sui-list-header>
          You have the right to withdraw from this contract within 14 days without giving any reason.
          The withdrawal period will expire after 14 days from the day of the conclusion of the contract.
          To exercise the right of withdrawal, you must inform us (LAN1 Hotspots GmbH, Gau&szlig;stra&szlig;e 158, 22765 Hamburg, Tel.: +49 (0)40 317 66 66 0, Fax: +49 (0)40 317 66 66 33, Email: info@lan1.de) of your decision to withdraw from this contract by an unequivocal statement (e.g. a letter sent by post, fax or e-mail). You may use the attached model withdrawal form, but it is not obligatory.
          To meet the withdrawal deadline, it is sufficient for you to send your communication concerning your exercise of the right of withdrawal before the withdrawal period has expired.
        </sui-list-content>
      </sui-list-item>
      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Effects of withdrawal</sui-list-header>
          If you withdraw from this contract, we shall reimburse to you all payments received from you, including the costs of delivery (with the exception of the supplementary costs resulting from your choice of a type of delivery other than the least expensive type of standard delivery offered by us), without undue delay and in any event not later than 14 days from the day on which we are informed about your decision to withdraw from this contract. We will carry out such reimbursement using the same means of payment as you used for the initial transaction, unless you have expressly agreed otherwise; in any event, you will not incur any fees as a result of such reimbursement.
        </sui-list-content>
      </sui-list-item>
    </sui-list>

    <h3>--- Attachment Model withdrawal form ---</h3>
    <pre>
Model withdrawal form
(complete and return this form only if you wish to withdraw from the contract)
- To
  LAN1 Hotspots GmbH
  Gau&szlig;stra&szlig;e 158
  22765 Hamburg
  Fax: +49 (0)40 317 66 66 33
  Email: info@lan1.de

- I/We (*) hereby give notice that I/We (*) withdraw from my/our (*) contract of sale of the following goods (*)/for the provision of the following service (*),
- Ordered on (*)/received on (*),
- Name of consumer(s),
- Address of consumer(s),
- Signature of consumer(s) (only if this form is notified on paper),
- Date
___________
(*) Delete as appropriate.
        </pre>
  </div>
</template>

<script>
  export default {
  }</script>
